const formatShipEquipmentInfo = (maker: string, type: string): string => {
  let result = '';

  if (maker?.trim() || type) {
    result = `- ${maker}${type ? `${maker && ', '}${type}` : ''}`;
  }

  return result;
};

const formatSupplierEquipmentInfo = (
  standardServices: string[] = [],
  customServices: string[] = [],
  makers: string[] = []
): string => {
  let result =
    standardServices.length || customServices.length || makers.length
      ? '- '
      : '';

  if (standardServices.length) {
    result += standardServices.join(', ');
  }

  if (customServices.length) {
    if (result.length > 2) {
      result += ', ';
    }
    result += customServices.join(', ');
  }

  if (makers.length) {
    if (result.length > 2) {
      result += ', ';
    }
    result += makers.join(', ');
  }

  return result;
};

export { formatShipEquipmentInfo, formatSupplierEquipmentInfo };
